import His from "@/views/Inventory/subs/His.vue";
import Items from "@/widgets/Items.vue";
import TxItems from "@/views/Inventory/subs/TxItems.vue";

import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	components: {
		His,
		Items,
		TxItems
	},
	data() {
		var validate_warehouse = (rule, value, callback) => {
			if (value === "") {
				callback();
			} else if (value._id == this.info.warehouse._id) {
				callback(new Error("不可选择相同仓库"));
			} else {
				callback();
			}
		};
		return {
			dataModelNames: ["Transaction", "Tx_item"],
			loadings: {
				main: false,
				create: false,
				insert: false
			},
			activeName: "op",

			rules: {
				warehouse: [
					{
						required: true,
						message: "请输入",
						trigger: "change",
						type: "object",
						fields: {
							name: { type: "string", required: true, message: "请选择" },
							_id: { type: "string", required: true, message: "请选择" }
						}
					}
				],
				customer: [
					{
						required: true,
						message: "请输入",
						trigger: "change",
						type: "object",
						fields: {
							name: { type: "string", required: true, message: "请选择" },
							_id: { type: "string", required: true, message: "请选择" }
						}
					}
				],
				target_warehouse: [
					{
						required: true,
						message: "请输入",
						trigger: "change",
						type: "object",
						fields: {
							name: { type: "string", required: true, message: "请选择" },
							_id: { type: "string", required: true, message: "请选择" }
						}
					},
					{ validator: validate_warehouse, trigger: "change" }
				],
				supplier: [
					{
						required: true,
						message: "请输入",
						trigger: "change",
						type: "object",
						fields: {
							name: { type: "string", required: true, message: "请选择" },
							_id: { type: "string", required: true, message: "请选择" }
						}
					}
				],
				express: [
					{
						required: true,
						message: "请输入"
					}
				],
				tracking_number: [
					{
						required: true,
						message: "请输入"
					}
				],
				tx_at: [
					{
						required: true,
						message: "请输入"
					}
				]
			},

			everEdited: false
		};
	},
	computed: {
		...mapState(["dataModels", "loadingDM"]),

		itemsDuplicateCheck() {
			let checks = {};
			for (let i = 0; i < this.info.items.length; i++) {
				//特么0 也是 false 哦！！！！
				checks[this.info.items[i].item._id] = i + 1;
			}
			return checks;
		},
		total_price() {
			let total_price = 0;
			for (let k in this.info.items) {
				total_price += parseFloat(this.info.items[k].total_price);
			}
			return (total_price - this.info.discount + this.info.express_fee).toFixed(2);
		},
		total_amount() {
			let total_amount = 0;
			for (let k in this.info.items) {
				total_amount += parseFloat(this.info.items[k].amount);
			}
			return total_amount;
		},
		hasGetTableDataModel() {
			return this.dataModelNames.every(val => {
				return this.dataModels[val] && this.dataModels[val]._id;
			});
		}
	},
	mounted() {
		this.refreshRoute();
		this.dataModelNames.forEach(val => {
			this.checkDataModel(val);
		});
	},
	methods: {
		...mapMutations(["checkDataModel"]),

		refreshRoute() {
			this.activeName = this.$route.params.tab;
		},
		doResetInsert() {
			this.doResetItems();
		},

		onInsertItems(items) {
			for (let k in items) {
				if (this.itemsDuplicateCheck[items[k].item._id]) {
					this.$message.error("录入数据有重复，请检查！");
					continue;
				}
				this.info.items.push(items[k]);
			}
		}
	},
	watch: {
		// 如果路由有变化，会再次执行该方法
		$route: "refreshRoute"
	}
};
